export interface ISectionI18n {
	readonly name: string;
	readonly locale: string;
}

export class SectionI18n implements ISectionI18n {
	private _name: string;
	private _locale: string;

	constructor(name: string, locale: string) {
		this._name = name;
		this._locale = locale;
	}

	public get name(): string {
		return this._name;
	}

	public get locale(): string {
		return this._locale;
	}
}
